<template>
  <div class="app-container-v2 no-bg full-size data-center">
    <div class="top-container flex vertical br6 bg-white">
      <div class="title-box flex jbetween">
        <div class="title-left flex acenter">
          <span class="title-text">{{$t('menu.dataCenter')}}</span>
        </div>
        <div class="title-right flex jend acenter">
          <el-input v-if="hasCustomReportPermission" v-model="search" class="input-v2 gray" :placeholder="$t('reportName')" suffix-icon="el-icon-search" clearable />
          <el-button v-if="false" plain class="button-v2">数据看板配置</el-button>
          <el-button v-if="hasCustomReportPermission && !isReadOnly" type="primary" class="button-v2 ml16" @click="addCustomReport">+ {{$t('customReport')}}</el-button>
        </div>
      </div>

      <div class="info-box flex jbetween acenter bg-white pl24 pr24">
        <div class="flex acenter">
          <img src="@/assets/img/v2/common/avatar-default-big.png" class="size70 br-circle mr20" />
          <div class="flex vertical jbetween">
            <span class="font-24 fw-600" style="height: auto; margin-bottom: 10px">{{ $userInfo.cusName }}</span>
            <select-cus @change="cusChange" :width="310"></select-cus>
            <div v-if="false" class="flex acenter mt15">
              <img src="@/assets/img/v2/common/post.png" class="size14 mr8" />
              <span class="font-14 color-606">北京-崇文门分部</span>
            </div>
          </div>
        </div>

        <div class="simple-stats-container flex jbetween acenter">
          <div v-for="i in 5" class="simple-stats-box flex vertical">
            <span class="font-16 color-1c">{{ infoNameList[i - 1] }}</span>
            <span class="simple-stats-count">{{ infoData[`v_9274000${i}`].value || 0 }}</span>
            <div class="compare-box flex acenter mt18">
              <span class="font-14 color-9 mr8">{{ $t('YoYLastMonth') }}</span>
              <span class="font-14 fw-500 color-9 mr2" :class="`${$handleCompare(infoData[`v_9274000${i}`].proportion)}-text`">{{ infoData[`v_9274000${i}`].proportion || '0%' }}</span>
              <img v-if="$handleCompare(infoData[`v_9274000${i}`].proportion) !== 'equal'" :src="require(`@/assets/img/v2/common/arrow-${$handleCompare(infoData[`v_9274000${i}`].proportion)}.png`)" class="arrow-img" />
            </div>
          </div>
        </div>
      </div>

      <div class="tabs-container flex pl4">
        <el-tabs v-model="currentTab" class="air-recover-element" :class="{'only-board': !hasCustomReportPermission, 'only-custom-report': !hasBoardPermission}" @tab-click="changeTab">
          <el-tab-pane v-if="hasBoardPermission" :label="$t('dataBoard')" name="数据看板" />
          <el-tab-pane v-if="hasCustomReportPermission" :label="$t('customReport')" name="自定义报表" />
        </el-tabs>
      </div>
    </div>

    <div class="content-container mt24">
      <board v-if="hasBoardPermission && getBoardData" v-show="currentTab === '数据看板'" ref="board" :info-data="infoData"></board>
      <custom-report v-if="hasCustomReportPermission && getReportData" v-show="currentTab === '自定义报表'" ref="customReport" :search="search"></custom-report>
    </div>
  </div>
</template>

<script>
import { infoData } from '@/api/v2/stats/data-center/board'
import Board from './components/Board/index.vue'
import CustomReport from './components/CustomReport/index.vue'
import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
import { mapGetters } from 'vuex';
export default {
  name: 'DataCenter',
  components: {
    Board,
    CustomReport,
    SelectCus
  },
  provide() {
    return {
      $cusIds:() => this.cusIds
    }
  },
  data() {
    return {
      getBoardData: false,
      getReportData: false,
      search: '',
      currentTab: '',
      // infoNameList: ['在职人数', '本月入职人数', '本月离职人数', '平均年龄', '平均司龄'],
      infoNameList: [this.$t('numberOfEmployees'), this.$t('joinedLastMonth'), this.$t('resignationLastMonth'), this.$t('averageAge'), this.$t('averageService')],
      infoData: {
        v_92740001: {}, // 在职人数
        v_92740002: {}, // 本月入职人数
        v_92740003: {}, // 本月离职人数
        v_92740004: {}, // 平均年龄
        v_92740005: {}, // 平均司龄
        v_92740006: [], // 籍贯分布统计数据
        nativePlace: [], // 籍贯字典
        v_92740009: {}, // 本月平均应发薪资
        v_92740010: {}, // 本月平均实发薪资
        v_92740011: {} // 本月平均人力成本
      },
      infoLoading: true,
      cusIds: []
    }
  },
  computed: {
    ...mapGetters([
      'isReadOnly'
    ]),
    hasBoardPermission() {
      return this.$permissionSet.has('hr_wage_new_report_data_board')
    },
    hasCustomReportPermission() {
      return this.$permissionSet.has('hr_wage_new_report_zdybb_new')
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // 如果两个权限都有，则按正常处理
      if (this.hasBoardPermission && this.hasCustomReportPermission) {
        this.currentTab = this.$getStore('dataCenter_currentTab') || '数据看板'
        this.changeTab()
      }
      // 如果两个权限都没有，则不做任何处理
      else if (!this.hasBoardPermission && !this.hasCustomReportPermission) {
        this.currentTab = ''
      }
      // 如果只有其中一个，则currentTab设置为仅有的一个
      else {
        this.currentTab = this.hasBoardPermission ? '数据看板' : '自定义报表'
        this.changeTab()
      }
      this.getInfo()
    },
    getInfo() {
      this.infoLoading = true
      const params = {
        cusIds: this.cusIds
      }
      infoData(params).then(res => {
        const data = res.data.data
        if (data.msg) {
          this.$msgError(data.msg)
          return
        }
        this.infoData = data
        this.infoLoading = false
      })
    },
    addCustomReport() {
      this.getReportData = true
      this.$nextTick(() => {
        this.$refs.customReport.addReport()
      })
    },
    changeTab() {
      // 首次切换tab时再进行渲染，节省系统资源
      if (this.currentTab === '数据看板') {
        this.getBoardData = true;
      } else {
        this.getReportData = true
      }
      this.$setStore('dataCenter_currentTab', this.currentTab)
    },
    // 客户筛选change事件
    cusChange({ data, checkedLabels, checkedValues }) {
      this.cusIds = checkedValues;
      this.getInfo();
      if (this.currentTab == '数据看板') {
        this.$refs.board.init();
      } else {
        this.$refs.customReport.getData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.data-center {
  .top-container {
    min-width: 1664px;
    height: 250px;
    background: #FFFFFF;

    .info-box {
      height: 155px;

      .simple-stats-box {
        width: 169px;
        margin-left: 70px;

        .simple-stats-count {
          font-size: 32px;
          font-family: FZYDCHJW--GB1-0, FZYDCHJW--GB1;
          font-weight: 600;
          color: #1C1C1C;
          line-height: 38px;
          border-right: 1px solid #DEDEDE;
          margin-top: 6px;
        }
        &:nth-last-child(2) {
          .simple-stats-count {
            border-right: none;
          }
        }
      }
    }
    .tabs-container {
      ::v-deep {
        .el-tabs__content {
          display: none !important;
        }
        .el-tabs__header {
          margin: 0 36px 0 0 !important;
        }
        .el-tabs__nav-wrap:after {
          background-color: transparent !important;
        }
        .el-tabs__item {
          color: #666666 !important;

          &.is-active {
            color: #1C1C1C !important;
          }
        }
        .el-tabs__active-bar {
          background-color: #FF9601 !important;
        }
        .only-board .el-tabs__active-bar {
          width: 56px !important;
        }
        .only-custom-report .el-tabs__active-bar {
          width: 70px !important;
        }
      }
    }
  }
  .content-container {
    min-width: 1664px;
  }
}
</style>
